'use client';
import type * as React from 'react';
import type { DropdownProps } from 'react-day-picker';
import { Icon } from '@/components/site/ui';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

/**
 * Month and year pickers of the calendar caption as the app's menus instead of the browser's
 * native select (owner, 2026-11-02). Menus close on a click outside and only one is open at a
 * time. react-day-picker listens for a change event on a select, so the value goes back in that
 * shape.
 */
export function DatePickerDropdown({ options = [], value, onChange, 'aria-label': ariaLabel, disabled }: DropdownProps) {
  const current = options.find((o) => String(o.value) === String(value));
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        disabled={disabled}
        aria-label={ariaLabel}
        className="inline-flex h-9 items-center gap-1 rounded-control px-2 text-sm font-semibold capitalize text-foreground hover:bg-neutral-50 focus-visible:shadow-focus focus-visible:outline-none"
      >
        {current?.label}
        <Icon name="arrow-down-01" size={16} className="text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="max-h-72 overflow-y-auto">
        {options.map((o) => (
          <DropdownMenuItem
            key={o.value}
            disabled={o.disabled}
            onSelect={() => onChange?.({ target: { value: String(o.value) } } as unknown as React.ChangeEvent<HTMLSelectElement>)}
            className={cn('capitalize', String(o.value) === String(value) && 'font-semibold text-medlux')}
          >
            {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
